import { render, staticRenderFns } from "./card-payments.vue?vue&type=template&id=37ae08e2&scoped=true&"
import script from "./card-payments.vue?vue&type=script&lang=js&"
export * from "./card-payments.vue?vue&type=script&lang=js&"
import style0 from "./card-payments.vue?vue&type=style&index=0&id=37ae08e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae08e2",
  null
  
)

export default component.exports